import { ptBR, enUS, es } from 'date-fns/locale';
import ptAnt from 'antd/es/locale/pt_BR';
import enAnt from 'antd/es/locale/en_US';
import esAnt from 'antd/es/locale/es_ES';
/**
 * Returns an object containing decimal and thousand separator
 * based on user's locale
 */
export const getNumberSeparators = () => {
  // default
  const res = {
    decimal: '.',
    thousand: '',
  };

  // convert a number formatted according to locale
  const str = parseFloat('1234.56').toLocaleString();

  // if the resulting number does not contain previous number
  // (i.e. in some Arabic formats), return defaults
  if (!str.match('1')) return res;

  // get decimal and thousand separators
  res.decimal = str.replace(/.*4(.*)5.*/, '$1');
  res.thousand = str.replace(/.*1(.*)2.*/, '$1');

  // return results
  return res;
};

export const getDateFnsLocale = (language: string) => {
  switch (language) {
    case 'pt':
      return ptBR;
    case 'en':
      return enUS;
    case 'es':
      return es;
    default:
      return enUS;
  }
};

export const getAntLocale = (language: string) => {
  switch (language) {
    case 'pt':
      return ptAnt;
    case 'en':
      return enAnt;
    case 'es':
      return esAnt;
    default:
      return enAnt;
  }
};

export const getLocaleString = (language: string) => {
  switch (language) {
    case 'pt':
      return 'pt-BR';
    case 'en':
      return 'en-US';
    case 'es':
      return 'es-ES';
    default:
      return 'pt-BR';
  }
};
